import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject, Subscription } from "rxjs";

@Component({
  selector: "app-feedback-chat",
  templateUrl: "./feedback-chat.component.html",
  styleUrls: ["./feedback-chat.component.scss"],
})
export class FeedbackChatComponent implements OnInit {
  isAnonymousVisible = false;
  subscription: Subscription;
  senderId?: number;
  eventSubject: Subject<string> = new Subject();

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.subscription = this.route.paramMap.subscribe((params) => {
      if (params.get("isanonym")) {
        let showAnonymous = params.get("isanonym") === "true";
        this.showAnonymous(showAnonymous);
      }

      if (params.get("senderId")) {
        let senderId = Number(params.get("senderId"));
        this.setSenderId(senderId);
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  showAnonymous(anonymously: boolean) {
    this.isAnonymousVisible = anonymously;
  }

  setSenderId(senderId: number) {
    this.senderId = senderId;
  }

  selectPhrase(phrase: string) {
    this.eventSubject.next(phrase);
  }
}
